<mat-card
    class="daxa-card orders-card mb-25 border-radius bg-white border-none d-block"
    [class.rtl-enabled]="themeService.isRTLEnabled()"
>
    <mat-card-header>
        <mat-card-title>
            <div class="orders-card__title">
                <span>{{ 'pie_dashboard.plant_list.kicker' | translate }}</span>
                <h5 class="mb-0">
                    {{ 'Plant_list' | translate }}
                </h5>
            </div>
        </mat-card-title>
        <mat-card-subtitle>
            <div class="search-box position-relative">
                <i class="material-symbols-outlined">search</i>
                <input
                    type="text"
                    class="input-search d-block w-100 border-none outline-0"
                    [placeholder]="'pie_dashboard.plant_list.search_placeholder' | translate"
                    (keyup)="applyFilter($event)"
                    #input
                >
            </div>
        </mat-card-subtitle>
    </mat-card-header>

    <mat-card-content>
        <div class="orders-table">
            <div class="table-responsive">
                <table mat-table [dataSource]="dataSource">
                    <ng-container matColumnDef="plantName">
                        <th mat-header-cell *matHeaderCellDef>
                            {{ 'Plant_Name' | translate }}, {{ 'City' | translate }}
                        </th>
                        <td mat-cell *matCellDef="let element">
                            <div class="plant-cell">
                                <div
                                    class="plant-avatar"
                                    [class.is-online]="getStatusType(element) === 'online'"
                                    [class.is-abnormal]="getStatusType(element) === 'abnormal'"
                                    [class.is-offline]="getStatusType(element) === 'offline'"
                                >
                                    <i class="material-symbols-outlined">solar_power</i>
                                </div>
                                <div>
                                    <strong>{{ element.plantName.name }}</strong>
                                    <span>{{ element.plantName.city }}</span>
                                </div>
                            </div>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="serialNumber">
                        <th mat-header-cell *matHeaderCellDef>
                            {{ 'Serial_Number' | translate }}
                        </th>
                        <td mat-cell *matCellDef="let element">
                            <span class="serial-chip">{{ element.serialNumber }}</span>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="production">
                        <th mat-header-cell *matHeaderCellDef>
                            {{ 'Production' | translate }}
                        </th>
                        <td mat-cell *matCellDef="let element">
                            <div class="metric-cell metric-cell--production">
                                <strong>{{ element.production | cultural }}</strong>
                                <span>kWh</span>
                            </div>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="consumption">
                        <th mat-header-cell *matHeaderCellDef>
                            {{ 'Consumption' | translate }}
                        </th>
                        <td mat-cell *matCellDef="let element">
                            <div class="metric-cell metric-cell--consumption">
                                <strong>{{ element.consumption | cultural }}</strong>
                                <span>kWh</span>
                            </div>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="batteryLevel">
                        <th mat-header-cell *matHeaderCellDef>
                            {{ 'Battery_Level' | translate }}
                        </th>
                        <td mat-cell *matCellDef="let element">
                            @if (getBatteryPercent(element) !== null) {
                                <div class="battery-cell">
                                    <div class="battery-cell__top">
                                        <strong>{{ getBatteryPercent(element) }}%</strong>
                                    </div>
                                    <div class="battery-track">
                                        <span [style.width.%]="getBatteryWidth(element)"></span>
                                    </div>
                                </div>
                            } @else {
                                <span class="no-battery">{{ 'pie_dashboard.common.no_battery' | translate }}</span>
                            }
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="startupDate">
                        <th mat-header-cell *matHeaderCellDef>
                            {{ 'Startup_Date' | translate }}
                        </th>
                        <td mat-cell *matCellDef="let element">
                            <span class="date-chip">{{ element.startupDate | cultural }}</span>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="status">
                        <th mat-header-cell *matHeaderCellDef>
                            {{ 'Status' | translate }}
                        </th>
                        <td mat-cell *matCellDef="let element">
                            <span
                                class="status-badge"
                                [class.is-online]="getStatusType(element) === 'online'"
                                [class.is-abnormal]="getStatusType(element) === 'abnormal'"
                                [class.is-offline]="getStatusType(element) === 'offline'"
                            >
                                <span></span>
                                {{ getStatusLabel(element) }}
                            </span>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="action">
                        <th mat-header-cell *matHeaderCellDef>
                            {{ 'Action' | translate }}
                        </th>
                        <td mat-cell *matCellDef="let element">
                            <button
                                mat-button
                                class="view-plant-btn"
                                [matTooltip]="'View_Plant' | translate"
                                matTooltipPosition="above"
                                (click)="viewPlant(element)"
                            >
                                <i class="material-symbols-outlined">{{ element.action.view }}</i>
                            </button>
                        </td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

                    <tr class="mat-row" *matNoDataRow>
                        <td class="mat-cell no-data-cell" colspan="8">
                            {{ 'pie_dashboard.plant_list.no_results' | translate:{ value: input.value } }}
                        </td>
                    </tr>
                </table>
            </div>

            <mat-paginator [pageSizeOptions]="[5, 10, 20]" showFirstLastButtons></mat-paginator>
        </div>
    </mat-card-content>
</mat-card>
